import { render, staticRenderFns } from "./Sistema.vue?vue&type=template&id=f26abbae&"
import script from "./Sistema.vue?vue&type=script&lang=js&"
export * from "./Sistema.vue?vue&type=script&lang=js&"
import style0 from "./Sistema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports